import axios from "axios";
const apiAdder = process.env.VUE_APP_API;
export async function getList() {
  const token = localStorage.getItem("token");
  return axios
    .get(`${apiAdder}account/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((rsp) => {
      return rsp.data;
    });
}
export async function getAccount(_, id) {
  const token = localStorage.getItem("token");
  return axios
    .get(`${apiAdder}account/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((rsp) => {
      return rsp.data;
    });
}
export async function deleteAccount(_, id) {
  const token = localStorage.getItem("token");
  return axios
    .delete(`${apiAdder}account/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((rsp) => {
      return rsp.data;
    });
}
export async function addAccount(_, data) {
  const token = localStorage.getItem("token");
  return axios
    .post(`${apiAdder}account/`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((rsp) => {
      return rsp.data;
    });
}
export async function addFinoAccount(_, data) {
  const token = localStorage.getItem("token");
  return axios
    .post(`${apiAdder}account/finno/create/`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((rsp) => {
      return rsp.data;
    });
}
export async function addFaraboomAccount(_, data) {
  const token = localStorage.getItem("token");
  return axios
    .post(`${apiAdder}faraboom/create/`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((rsp) => {
      return rsp.data;
    });
}
export async function chengAccountName(_, data) {
  const token = localStorage.getItem("token");
  return axios
    .patch(`${apiAdder}account/${data.id}/`, data.updateData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((rsp) => {
      return rsp.data;
    });
}

export async function getBanksList() {
  return axios.get(`${apiAdder}bank/`).then((rsp) => {
    return rsp.data;
  });
}
